module.exports = __webpack_public_path__ + "media/images/instagram-c9fd468ce37ba17627874c9af2e0683c.svg";